export const API_VERSION = "v1";

export const apiRoutes = {
  groupListAll: `/${API_VERSION}/group/list-all`,
  groupListAllEvents: `/${API_VERSION}/group/events-all`,
  groupList: `/${API_VERSION}/group/list`,
  groupUpdateGroup: `/${API_VERSION}/group/update-group`,
  groupRemove: `/${API_VERSION}/group/remove`,
  uploadPayment: `/${API_VERSION}/group/event-upload-payment`,
  updatePayment: `/${API_VERSION}/group/event-update-payment`,
  eventUpdateEvent: `/${API_VERSION}/group/update-event`,
  eventAllowEditEvent: `/${API_VERSION}/group/allow-edit-event`,
  updateEvent: `/${API_VERSION}/group/update-event`,
  removeEvent: `/${API_VERSION}/group/remove-event`,
  eventInscription: `/${API_VERSION}-public/event/inscription`,
  activeEvents: `/${API_VERSION}/group/active-events`,
  updateParticipant: `/${API_VERSION}/group/update-participant`,
  removeParticipant: `/${API_VERSION}/group/remove-participant`,
  participantLog: `/${API_VERSION}/group/participant/log`,
  groupListAllPayments: (date: string) => `/${API_VERSION}/group/all-event-payments?date=${date}`,
  eventPublicData: (groupId: string) => `/${API_VERSION}-public/event/${groupId}`,
  eventData: (groupId: string) => `/${API_VERSION}/group/events/${groupId}`,
  guestPublicData: (guestId: string) => `/${API_VERSION}-public/event/guest/${guestId}`,
  eventParticipants: (eventId: string) => `/${API_VERSION}/group/participants/${eventId}`,
  eventsStatistics: (date: string) => `/${API_VERSION}/group/event/statistics/${date}`,
  nextEvents: `/${API_VERSION}/group/events-to-move`,
  moveParticipants: `/${API_VERSION}/group/move-next-time`,
  moveParticipantsToEvent: `/${API_VERSION}/group/participant/move`,
  declineNonAttending: `/${API_VERSION}/group/participant/decline-non-attending`,
  analyzeReceipt: `/${API_VERSION}/analyze-receipt`,
  autoAssignRooms: (eventId: string) => `/${API_VERSION}/group/event/room-assign/${eventId}`,
  updateRoom: `/${API_VERSION}/group/room/edit`,
  updateParticipantRoom: `/${API_VERSION}/group/participant/edit-room`,
  serversRoomReservation: (eventId: string) => `/${API_VERSION}/group/event/servers-room-reservation/${eventId}`,
  updateWorkshop: `/${API_VERSION}/group/event/edit-workshop`,
  removeWorkshop: `/${API_VERSION}/group/event/remove-workshop`,
  addWorkshop: `/${API_VERSION}/group/event/add-workshop`,
  updateParticipantWorkshop: `/${API_VERSION}/group/participant/edit-workshop`,
  updateStatus: `/${API_VERSION}/group/participant/edit-status`,
  updateParticipantPaymentConfig: `/${API_VERSION}/group/participant/edit-payment-config`,
  updateParticipantCarInfo: `/${API_VERSION}/group/participant/edit-car-info`,
  updateParticipantCalls: `/${API_VERSION}/group/participant/edit-call-history`,
  updateEventComission: `/${API_VERSION}/group/event/update-comission`,
  updateWorkshopsByAge: `/${API_VERSION}/group/event/assign-workshops-by-age`,
  updateWorkshopsRandomly: `/${API_VERSION}/group/event/assign-workshops`,
  updateEventServersFromCommitment: `/${API_VERSION}/group/event/assign-from-servers`,
  // invitations
  invitationList: `/${API_VERSION}/invitation/list`,
  invitationUpdate: `/${API_VERSION}/invitation/update-invitation`,
  invitationRemove: `/${API_VERSION}/invitation/remove-invitation`,
  invitationByCode: (code: string) => `/${API_VERSION}-public/invitation/${code}`,
  invitationGuests: (invitationId: string) => `/${API_VERSION}/invitation/guests?id=${invitationId}`,
  invitationConfirmation: `/${API_VERSION}-public/invitation-public/confirmation`,
  invitationGuestUpdate: `/${API_VERSION}/invitation/update-guest`,
  invitationGuestRemove: `/${API_VERSION}/invitation/remove-guest`,
  invitationGuestByHash: (hash: string) => `/${API_VERSION}-public/invitation/guest/${hash}`,
  invitationUploadImage: `/${API_VERSION}/upload-image`,
  // servers and meetings
  groupServers: (groupId: string) => `/${API_VERSION}/group/servers?id=${groupId}`,
  groupMeetings: (groupId: string) => `/${API_VERSION}/group/meetings?id=${groupId}`,
  groupMeetingData: (groupId: string) => `/${API_VERSION}/group/meeting-data?id=${groupId}`,
  serverUpdate: `/${API_VERSION}/group/update-servers`,
  serverRemove: `/${API_VERSION}/group/remove-server`,
  meetingUpdate: `/${API_VERSION}/group/update-meeting`,
  meetingRemove: `/${API_VERSION}/group/remove-meeting`,
  addNextMeetingDate: `/${API_VERSION}/group/add-next-date`,
  // services
  servicesList: (meetingId: string) => `/${API_VERSION}/group/meeting-services?id=${meetingId}`,
  serviceUpdate: `/${API_VERSION}/group/update-services`,
  serviceSingleUpdate: `/${API_VERSION}/group/update-single-service`,
  serviceRemove: `/${API_VERSION}/group/remove-services`,
  // meeting attendance
  meetingAttendanceRecords: (meetingServiceId: string, groupId: string) =>
    `/${API_VERSION}/group/meeting-attendance?meetingServiceId=${meetingServiceId}&groupId=${groupId}`,
  meetingAttendanceUpdate: `/${API_VERSION}/group/update-meeting-attendance`,
  publicMeetingAttendanceInfo: (params: {
    groupId?: string;
    meetingId?: string;
    code?: string;
    clientDate?: string;
  }) => {
    const query = new URLSearchParams();
    if (params.groupId) query.append("groupId", params.groupId);
    if (params.meetingId) query.append("meetingId", params.meetingId);
    if (params.code) query.append("code", params.code);
    if (params.clientDate) query.append("clientDate", params.clientDate);
    return `/${API_VERSION}-public/group-meeting-attendance/public/info?${query.toString()}`;
  },

  publicMeetingAttendanceMark: `/${API_VERSION}-public/group-meeting-attendance/public/mark`,

  // group services
  groupServiceUpdate: `/${API_VERSION}/group/update-service`,
  groupServiceRemove: `/${API_VERSION}/group/remove-group-service`,
  groupServiceTypes: (groupId: string) => `/${API_VERSION}/group/service-types?id=${groupId}`,
  groupServiceTypeUpdate: `/${API_VERSION}/group/update-service-type`,
  groupServiceTypeRemove: `/${API_VERSION}/group/remove-service-type`,
  servicesDashboard: `/${API_VERSION}/group/dashboard`,
  groupServicesHistory: `/${API_VERSION}/group/services-history`,
  serversAttendanceData: `/${API_VERSION}/group/meeting-attendance-report`,
  createServiceServer: `/${API_VERSION}/group/create-server`,
  // commitment
  commmitmentByHash: (hash: string) => `/${API_VERSION}-public/commitment/${hash}`,
  commitmentGroupByCode: (code: string) => `/${API_VERSION}-public/group/${code}`,
  commitmentRegister: `/${API_VERSION}-public/commitment/inscription`,
  commitmentGuestRegister: `/${API_VERSION}-public/commitment/guest-inscription`,
  commitmentList: `/${API_VERSION}/commitment/list`,
  currentCommitment: `/${API_VERSION}/commitment/current`,
  commitmentServers: (commitmentId: string, groupId: string) =>
    `/${API_VERSION}/commitment/servers?id=${commitmentId}&groupId=${groupId}`,
  lastCommitmentServers: (groupId: string) => `/${API_VERSION}-public/commitment/current-servers/${groupId}`,
  commitmentGuests: (commitmentId: string) => `/${API_VERSION}/commitment/guests?id=${commitmentId}`,
  commitmentVerifyServerByPhone: `/${API_VERSION}-public/commitment/verify-server-by-phone`,
  commitmentInscriptionByGroup: (commitmentHash: string, groupCode: string) =>
    `/${API_VERSION}-public/commitment/servers/${commitmentHash}/${groupCode}`,
  commitmentDashboard: `/${API_VERSION}/commitment/servers`,
  commitmentServerUpdate: `/${API_VERSION}/commitment/update-server`,
  commitmentServerAttendanceUpdate: `/${API_VERSION}-public/commitment/update-server-attendance`,
  commitmentServerPayment: `/${API_VERSION}/commitment/upload-payment`,
  commitmentServerRemove: `/${API_VERSION}/commitment/remove-server`,
  commitmentServerUploadProfilePicture: `/${API_VERSION}/commitment/upload-profile-picture`,

  prayerRequestList: `/${API_VERSION}/prayer-request`,
  prayerRequestUpdate: `/${API_VERSION}/prayer-request/update`,
  prayerRequestRemove: `/${API_VERSION}/prayer-request/remove`,
  prayerRequestById: (id: string) => `/${API_VERSION}/prayer-request/${id}`,
  prayerRequestDetails: (id: string) => `/${API_VERSION}/prayer-request/${id}/details`,
  prayerRequestPublic: (code: string) => `/${API_VERSION}-public/prayer-request/${code}`,
  prayerRequestPublicDetail: `/${API_VERSION}-public/prayer-request/detail`,

  // preaching
  preachingSermons: `/${API_VERSION}/preaching/sermons`,
  preachingSermonsByPreacher: (preacherId: string) => `/${API_VERSION}/preaching/sermons/preacher/${preacherId}`,
  preachingSermonUpdate: `/${API_VERSION}/preaching/sermon/update`,
  preachingSermonRemove: `/${API_VERSION}/preaching/sermon/remove`,
  preachingSermonResources: (sermonId: string) => `/${API_VERSION}/preaching/sermon/${sermonId}/resources`,
  preachingResourceUpdate: `/${API_VERSION}/preaching/resource/update`,
  preachingResourceRemove: `/${API_VERSION}/preaching/resource/remove`,
  preachingEvents: `/${API_VERSION}/preaching/events`,
  preachingEventsByGroup: (groupId: string) => `/${API_VERSION}/preaching/events/group/${groupId}`,
  preachingEventsByPreacher: (preacherId: string) => `/${API_VERSION}/preaching/events/preacher/${preacherId}`,
  preachingEventUpdate: `/${API_VERSION}/preaching/event/update`,
  preachingEventRemove: `/${API_VERSION}/preaching/event/remove`,
  preachingMeetings: `/${API_VERSION}/preaching/meetings`,
  preachingMeetingUpdate: `/${API_VERSION}/preaching/meeting/update`,
  preachingGroupBlockedDatesUpdate: `/${API_VERSION}/preaching/group/blocked-dates`,
  preachingMeetingAttendance: (meetingId: string) => `/${API_VERSION}/preaching/meeting/${meetingId}/attendance`,
  preachingAttendanceUpdate: `/${API_VERSION}/preaching/meeting/attendance/update`,
  preachingPreference: (preacherId: string) => `/${API_VERSION}/preaching/preference/${preacherId}`,
  preachingPreferences: `/${API_VERSION}/preaching/preferences`,
  preachingPreferenceUpdate: `/${API_VERSION}/preaching/preference/update`,
  preachingGenerateAssignments: `/${API_VERSION}/preaching/generate-assignments`,
  preachingNotifyAll: `/${API_VERSION}/preaching/notify`,
  preachingNotifyPreacher: `/${API_VERSION}/preaching/notify/preacher`,
  preachingDashboardStats: (params?: { startDate?: string; endDate?: string }) => {
    const query = new URLSearchParams();
    if (params?.startDate) query.append("startDate", params.startDate);
    if (params?.endDate) query.append("endDate", params.endDate);
    const qs = query.toString();
    return `/${API_VERSION}/preaching/dashboard/stats${qs ? `?${qs}` : ""}`;
  },

  // home settings
  homeSettingsGet: `/${API_VERSION}-public/home-settings`,
  homeSettingsUpdate: `/${API_VERSION}/home-settings/update`,

  // ministries
  ministryPublicListAll: `/${API_VERSION}-public/ministry-list-all`,
  ministryListAll: `/${API_VERSION}/ministry/list-all`,
  ministryCreate: `/${API_VERSION}/ministry/create-ministry`,
  ministryUpdate: `/${API_VERSION}/ministry/update-ministry`,
  ministryRemove: `/${API_VERSION}/ministry/remove`
};
